import {EditorState} from 'prosemirror-state';

export const inListItem = (state: EditorState) => {
  const {$from} = state.selection;

  return !!($from.depth && $from.node($from.depth - 1).type.name === 'list_item');
};
